import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from './EditStakeholders.styles'
import { OfferStakeholders } from '../../../types/flyout'
import { useSelector } from '../../../store'
import {
  customStakeholdersValidation,
  offerStakeholdersValidation,
} from '../../utils/offerStakeholdersValidation'
import { EditOfferStakeholdersForm } from '../EditOfferStakeholdersForm/EditOfferStakeholdersForm'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'
import { StakeholderUserOption } from '../ViewStakeholders/stakeholderUserOption'

export const EditStakeholders = ({
  offerStakeholders,
  customOfferStakeholders,
  handleCloseStakeholders,
  handleSubmit,
  isUpdateLoading,
  hideStakeholders,
  users = [],
}: {
  offerStakeholders: OfferStakeholders[]
  customOfferStakeholders: OfferStakeholders[]
  handleCloseStakeholders: () => void
  handleSubmit?: (
    offerStakeholders: OfferStakeholders[],
    customOfferStakeholders: OfferStakeholders[]
  ) => void
  isUpdateLoading?: boolean
  hideStakeholders?: boolean
  users?: StakeholderUserOption[]
}) => {
  const { classes } = useStyles()
  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.GENERAL)
  )
  const initialValuesStakeholders = {
    offerStakeholders: offerStakeholders,
    customOfferStakeholders: customOfferStakeholders,
  }

  const handleSubmitStakeholders = async (values: {
    offerStakeholders: OfferStakeholders[]
    customOfferStakeholders: OfferStakeholders[]
  }) => {
    if (handleSubmit) {
      handleSubmit(values.offerStakeholders, values.customOfferStakeholders)
    }
  }

  const validationSchema = hideStakeholders
    ? customStakeholdersValidation
    : Yup.object().shape(offerStakeholdersValidation)
  return (
    <Formik
      initialValues={initialValuesStakeholders}
      validationSchema={validationSchema}
      validateOnMount={true}
      onSubmit={async values => {
        await handleSubmitStakeholders(values)
      }}
      enableReinitialize
    >
      {formikProps => {
        const submitForm = async () => {
          await formikProps?.submitForm()
        }

        return (
          <Form>
            <EditOfferStakeholdersForm
              hideStakeholders={hideStakeholders}
              users={users}
            />
            <div className={classes.rowRightItem}>
              <ButtonV2
                data-testid="cancel-stakeholder"
                smallVariant
                styleType="outlined"
                onClick={handleCloseStakeholders}
              >
                Cancel
              </ButtonV2>

              <ButtonV2
                data-testid="save-stakeholder"
                smallVariant
                styleType="primary"
                onClick={submitForm}
                loading={isUpdateLoading || isLoading}
              >
                Save
              </ButtonV2>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
